document.addEventListener("DOMContentLoaded", function () {
  // ELEMENTS
  const submitButton = document.querySelector("#submit-button");
  const form = document.querySelector(".contact-v2-form");
  const ffInputBlockSubmit = form.querySelectorAll("ff-input-block-submit");

  // --- FORM ELEMENTS ----------------------
  const numberOfRoomsArray = document.querySelectorAll(".estancias");
  const onlyOneRoomElement = document.getElementById("estancias-Una");
  
  // Estancias selects
  const secondRoomSelect = document.getElementById("cuanto-mide-cada-estancia-2");
  
  // Estancias m2
  const firstRoomM2 = document.getElementById("m2-room-cuanto-mide-cada-estancia");
  const secondRoomM2 = document.getElementById("m2-room-cuanto-mide-cada-estancia-2");
  
  // Unidad exterior
  const unidadExteriorParent = document.querySelector('[data-field-type="unidad_exterior"]');
  const unidadExteriorParent2 = document.querySelector('[data-field-type="unidad_exterior_2"]');
  
  let unidadExteriorParentInputs = [];
  let unidadExteriorParentInputs2 = [];
  
  if (unidadExteriorParent) {
    unidadExteriorParentInputs = unidadExteriorParent.querySelectorAll('input[type="radio"]');
  }
  
  if (unidadExteriorParent2) {
    unidadExteriorParentInputs2 = unidadExteriorParent2.querySelectorAll('input[type="radio"]');
  }

  const unidadExteriorParentInputsPrimeros = [
    unidadExteriorParentInputs[0],
    unidadExteriorParentInputs[1],
  ].filter(Boolean);
  
  const unidadExteriorParentInputsUltimos = [
    unidadExteriorParentInputs[2],
    unidadExteriorParentInputs[3],
  ].filter(Boolean);

  const unidadExteriorParentInputsPrimeros2 = [
    unidadExteriorParentInputs2[0],
    unidadExteriorParentInputs2[1],
  ].filter(Boolean);
  
  const unidadExteriorParentInputsUltimos2 = [
    unidadExteriorParentInputs2[2],
    unidadExteriorParentInputs2[3],
  ].filter(Boolean);

  // Distancia azotea
  const distanciaAzoteaParent = document.getElementById("distancia_azotea-parent");
  let distanciaAzoteaChilds = [];
  if (distanciaAzoteaParent) {
    distanciaAzoteaChilds = distanciaAzoteaParent.querySelectorAll('input[type="radio"]');
  }
  
  // Distancia balcon patio
  const distanciaBalconPatioParent = document.getElementById("distancia_balcon_patio-parent");
  const distanciaBalconPatioParent2 = document.getElementById("distancia_balcon_patio_2-parent");
  
  let distanciaBalconPatioChilds = [];
  let distanciaBalconPatioChilds2 = [];
  
  if (distanciaBalconPatioParent) {
    distanciaBalconPatioChilds = distanciaBalconPatioParent.querySelectorAll('input[type="radio"]');
  }
  
  if (distanciaBalconPatioParent2) {
    distanciaBalconPatioChilds2 = distanciaBalconPatioParent2.querySelectorAll('input[type="radio"]');
  }

  // --- END FORM INPUTS -----------------------------

  function unidadExteriorInputsEvents() {
    unidadExteriorParentInputsPrimeros.forEach((input) => {
      if (input) {
        input.addEventListener("click", () => hideDistanciaAzotea(1));
      }
    });
    
    unidadExteriorParentInputsUltimos.forEach((input) => {
      if (input) {
        input.addEventListener("click", () => hideDistanciaBalconPatio(1));
      }
    });
    
    unidadExteriorParentInputsPrimeros2.forEach((input) => {
      if (input) {
        input.addEventListener("click", () => hideDistanciaAzotea(2));
      }
    });
    
    unidadExteriorParentInputsUltimos2.forEach((input) => {
      if (input) {
        input.addEventListener("click", () => hideDistanciaBalconPatio(2));
      }
    });
  }

  function toggleVisibility(parent, childs, isHidden) {
    if (parent) {
      parent.style.display = isHidden ? "none" : "block";
    }
    
    childs.forEach((input) => {
      if (input) {
        input.dataset.isHidden = isHidden.toString();
        // Añadir/quitar disabled
        input.disabled = isHidden;
        // También manejar el label si existe
        const label = input.closest("label");
        if (label) {
          if (isHidden) {
            label.setAttribute("disabled", "");
          } else {
            label.removeAttribute("disabled");
          }
        }
      }
    });
  }

  function hideDistanciaAzotea(param) {
    toggleVisibility(distanciaAzoteaParent, distanciaAzoteaChilds, true);
    if (param === 1) {
      toggleVisibility(distanciaBalconPatioParent, distanciaBalconPatioChilds, false);
    } else {
      toggleVisibility(distanciaBalconPatioParent2, distanciaBalconPatioChilds2, false);
    }
  }

  function hideDistanciaBalconPatio(param) {
    toggleVisibility(distanciaAzoteaParent, distanciaAzoteaChilds, false);
    if (param === 1) {
      toggleVisibility(distanciaBalconPatioParent, distanciaBalconPatioChilds, true);
    } else {
      toggleVisibility(distanciaBalconPatioParent2, distanciaBalconPatioChilds2, true);
    }
  }

  function formSubmitEvent() {
    if (form) {
      form.addEventListener("submit", function (event) {
        // Abrir el modal de contacto como componente de éxito
        sessionStorage.setItem("contact_modal_should_open", "true");
      });

      // Prevenir el envío por tecla Enter
      form.addEventListener("keypress", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          return false;
        }
      });
    }
  }

  // Initialize form validations
  function initializeValidations() {
    ffInputBlockSubmit.forEach((input) => {
      if (input.init && typeof input.init === 'function') {
        input.init();
      }
    });
  }

  // Room M2 input events
  if (secondRoomM2) {
    secondRoomM2.addEventListener("input", (e) => {
      if (submitButton && firstRoomM2) {
        if (e.target.value > 0 && firstRoomM2.value > 0) {
          submitButton.disabled = false;
        } else {
          submitButton.disabled = true;
        }
      }
    });
  }
  
  if (firstRoomM2) {
    firstRoomM2.addEventListener("input", (e) => {
      if (submitButton) {
        if (e.target.value > 0) {
          submitButton.disabled = false;
        } else {
          submitButton.disabled = true;
        }
      }
    });
  }

  function updateRooms() {
    numberOfRoomsArray.forEach((room) => {
      room.addEventListener("click", function () {
        const estancia2Container = document.getElementById("cuanto-mide-cada-estancia-2-parent");
        
        if (room.id === "estancias-Una") {
          // Una estancia seleccionada
          if (estancia2Container) {
            estancia2Container.style.display = "none";
          }
          if (secondRoomSelect) {
            secondRoomSelect.disabled = true;
          }
          if (secondRoomM2) {
            secondRoomM2.disabled = true;
          }
          
          // Mostrar primera unidad exterior
          if (unidadExteriorParent) {
            unidadExteriorParent.style.display = "block";
            unidadExteriorParentInputs.forEach((input) => {
              if (input) input.disabled = false;
            });
          }
          
          // Ocultar segunda unidad exterior
          if (unidadExteriorParent2) {
            unidadExteriorParent2.style.display = "none";
            unidadExteriorParentInputs2.forEach((input) => {
              if (input) input.disabled = true;
            });
          }
          
          // Mostrar primera distancia balcon patio
          if (distanciaBalconPatioParent) {
            distanciaBalconPatioParent.style.display = "block";
            distanciaBalconPatioChilds.forEach((input) => {
              if (input) input.disabled = false;
            });
          }
          
          // Ocultar segunda distancia balcon patio
          if (distanciaBalconPatioParent2) {
            distanciaBalconPatioParent2.style.display = "none";
            distanciaBalconPatioChilds2.forEach((input) => {
              if (input) {
                input.disabled = true;
                input.setAttribute("data-is-hidden", "true");
              }
            });
          }

          // Lógica para la primera unidad exterior
          const selected = Array.from(unidadExteriorParentInputs).find((input) => input && input.checked);
          if (selected) {
            const value = selected.parentElement.textContent.trim();
            if (value === "Balcón" || value === "Patio interior") {
              hideDistanciaAzotea(1);
            } else {
              hideDistanciaBalconPatio(1);
            }
          }

          if (firstRoomM2 && submitButton && firstRoomM2.value > 0) {
            submitButton.disabled = false;
          }
        } else {
          // Dos o más estancias seleccionadas
          if (estancia2Container) {
            estancia2Container.style.display = "block";
          }
          if (secondRoomSelect) {
            secondRoomSelect.disabled = false;
          }
          if (secondRoomM2) {
            secondRoomM2.disabled = false;
          }
          
          // Ocultar primera unidad exterior
          if (unidadExteriorParent) {
            unidadExteriorParent.style.display = "none";
            unidadExteriorParentInputs.forEach((input) => {
              if (input) input.disabled = true;
            });
          }
          
          // Mostrar segunda unidad exterior
          if (unidadExteriorParent2) {
            unidadExteriorParent2.style.display = "block";
            unidadExteriorParentInputs2.forEach((input) => {
              if (input) input.disabled = false;
            });
          }
          
          // Ocultar primera distancia balcon patio
          if (distanciaBalconPatioParent) {
            distanciaBalconPatioParent.style.display = "none";
            distanciaBalconPatioChilds.forEach((input) => {
              if (input) input.disabled = true;
            });
          }
          
          // Mostrar segunda distancia balcon patio
          if (distanciaBalconPatioParent2) {
            distanciaBalconPatioParent2.style.display = "block";
            distanciaBalconPatioChilds2.forEach((input) => {
              if (input) {
                input.disabled = false;
                input.setAttribute("data-is-hidden", "false");
              }
            });
          }

          // Lógica para la segunda unidad exterior
          const selected = Array.from(unidadExteriorParentInputs2).find((input) => input && input.checked);
          if (selected) {
            const value = selected.parentElement.textContent.trim();
            if (value === "Balcón" || value === "Patio interior") {
              hideDistanciaAzotea(2);
            } else {
              hideDistanciaBalconPatio(2);
            }
          }
        }
      });
    });
  }

  // Initialize everything
  if (numberOfRoomsArray.length > 0) {
    updateRooms();
  }
  
  if (unidadExteriorParentInputs.length > 0 || unidadExteriorParentInputs2.length > 0) {
    unidadExteriorInputsEvents();
  }
  
  // Initialize validations after DOM is ready
  setTimeout(() => {
    initializeValidations();
  }, 100);
  
  formSubmitEvent();

  // Auto-select first room option if available
  if (onlyOneRoomElement) {
    setTimeout(() => {
      onlyOneRoomElement.click();
      if (submitButton) {
        submitButton.disabled = true;
      }
    }, 200);
  }
});